/**
 * SHA-1 hex digest of `plain` (UTF-8), matching GNU `sha1sum` on the same bytes:
 * `echo -n "password" | sha1sum` (lowercase hex, no trailing newline).
 */
export async function hashLocalPassword(plain: string): Promise<string> {
  const enc = new TextEncoder();
  const buf = await crypto.subtle.digest(
    'SHA-1',
    enc.encode(plain),
  );
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
